import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Pricing() {
  return <section id="comprar" className="bg-brand-darkgreen py-24 px-6" data-id="element-43">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-44">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-[2rem] md:text-[2.4rem] text-white text-center mb-16 leading-tight" data-id="element-45">
          Acceso inmediato. Descarga instantánea.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="w-full max-w-[480px] bg-white/5 border border-white/20 rounded-3xl p-10 text-center backdrop-blur-sm" data-id="element-46">
          <div className="mb-8" data-id="element-47">
            <div className="text-white/50 line-through text-xl mb-2 font-medium" data-id="element-48">
              $35.000 ARS
            </div>
            <div className="text-brand-mint font-serif font-bold text-[4rem] leading-none mb-4" data-id="element-49">
              $24.990
            </div>
            <div className="text-white/90 text-sm uppercase tracking-wider font-bold" data-id="element-50">
              ARS · Precio especial de lanzamiento
            </div>
          </div>

          <CTAButton fullWidth href="https://www.soportesaberdigital.com/cart/49830682165487:1" className="text-xl py-5 mb-8" data-id="element-51">
            Quiero la guía + APP Digital →
          </CTAButton>

          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-white/55 text-sm font-medium" data-id="element-52">
            <div className="flex items-center gap-1.5" data-id="element-53">
              <LockIcon size={16} data-id="element-54" />
              <span data-id="element-55">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-56">
              <ShieldCheckIcon size={16} data-id="element-57" />
              <span data-id="element-58">Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-59">
              <LockIcon size={16} data-id="element-60" />
              <span data-id="element-61">Acceso de por vida</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}